// extracted by mini-css-extract-plugin
export default {"mobileWidth":"980px","desktopWidth":"1520px","root":"topAward_root__RwqrG","title":"topAward_title__sgYDr","contentIcon":"topAward_contentIcon__5Rdm6"};